import React from "react";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import classes from "./TabErrorIcon.module.css";

const TabErrorIcon = () => (
  <ExclamationCircleFill className={classes.errorInTab} />
);

export default TabErrorIcon;
